import { useLendingApplicationID } from "@lending/hooks/useLendingApplicationID";
import { useApi } from "@lending/lib/api";

interface Options {
  enabled?: boolean;
}

function useListApplicantIncomeDetailsQuery({ enabled = true }: Options = {}) {
  const $api = useApi();
  const lendingApplicationID = useLendingApplicationID();

  return $api.useQuery(
    "get",
    "/v2/lending/applicant_income_details/",
    {
      params: {
        query: {
          application: lendingApplicationID,
        },
      },
    },
    { enabled: Boolean(lendingApplicationID) && enabled }
  );
}

export { useListApplicantIncomeDetailsQuery };
